import { StatusVariant } from '@factorialco/f0-react'
import { PerformanceReviewProcessStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const getStatusMapping = (
  status: PerformanceReviewProcessStatusEnum
): [string, StatusVariant] => {
  switch (status) {
    case 'draft':
      return [i18n.t('performance_process.reviews.review_status.draft'), 'warning']
    case 'scheduled':
      return [i18n.t('performance_process.reviews.review_status.scheduled'), 'info']
    case 'active':
      return [i18n.t('performance_process.reviews.review_status.active'), 'positive']
    case 'finished':
      return [i18n.t('performance_process.reviews.review_status.finished'), 'neutral']
  }
}
